import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_NETWORK_ID = '/networks';

export const SET_NETWORK_ID_LOADING = 'SET_NETWORK_ID_LOADING';
export const GO_TO_NETWORK_ID_CREATE = 'GO_TO_NETWORK_ID_CREATE';
export const GO_TO_NETWORK_ID_VIEW = 'GO_TO_NETWORK_ID_VIEW';
export const GO_TO_NETWORK_ID_COPY = 'GO_TO_NETWORK_ID_COPY';
export const GO_TO_NETWORK_ID_LIST = 'GO_TO_NETWORK_ID_LIST';
export const GET_NETWORK_ID_LIST = 'GET_NETWORK_ID_LIST';
export const GET_NETWORK_ID_LIST_PENDING = 'GET_NETWORK_ID_LIST_PENDING';
export const GET_NETWORK_ID_LIST_FULFILLED = 'GET_NETWORK_ID_LIST_FULFILLED';
export const GET_NETWORK_ID = 'GET_NETWORK_ID';
export const GET_NETWORK_ID_PENDING = 'GET_NETWORK_ID_PENDING';
export const GET_NETWORK_ID_FULFILLED = 'GET_NETWORK_ID_FULFILLED';
export const CREATE_NETWORK_ID = 'CREATE_NETWORK_ID';
export const CREATE_NETWORK_ID_PENDING = 'CREATE_NETWORK_ID_PENDING';
export const CREATE_NETWORK_ID_FULFILLED = 'CREATE_NETWORK_ID_FULFILLED';
export const CREATE_NETWORK_ID_REJECTED = 'CREATE_NETWORK_ID_REJECTED';
export const UPDATE_NETWORK_ID = 'UPDATE_NETWORK_ID';
export const UPDATE_NETWORK_ID_FULFILLED = 'UPDATE_NETWORK_ID_FULFILLED';
export const UPDATE_NETWORK_ID_REJECTED = 'UPDATE_NETWORK_ID_REJECTED';
export const DELETE_NETWORK_ID = 'DELETE_NETWORK_ID';
export const DELETE_NETWORK_ID_FULFILLED = 'DELETE_NETWORK_ID_FULFILLED';
export const DELETE_NETWORK_ID_REJECTED = 'DELETE_NETWORK_ID_REJECTED';
export const SELECT_NETWORK_ID = 'SELECT_NETWORK_ID';

export enum NetworkIdPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}

export interface NetworkId {
  id?: string
  networkId: string,
  ownIPAddress: string,
  startPortNumber: string,
  portNumberRange: string
}

export interface NetworkIdState {
  entities: NetworkId[]
  selected: NetworkId[],
  single: NetworkId | null
  createdId: string | null
  ui: NetworkIdsUIState
  networksToSipSettings: NetworkId[] | undefined,
}

export interface NetworkIdsUIState {
  isCreatePopupOpen: boolean
  isLoading: boolean
}

export interface GoToNetworkIdListAction extends AnyAction {
  type: typeof GO_TO_NETWORK_ID_LIST
}

export interface SetNetworkIdLoadingAction extends AnyAction {
  type: typeof SET_NETWORK_ID_LOADING
  payload: { isLoading: boolean }
}

export interface GetNetworkIdListAction extends AnyAction {
  type: typeof GET_NETWORK_ID_LIST
  payload: AxiosPromise<ServerResponse<NetworkId>>
}

export interface GetNetworkIdListPendingAction extends AnyAction {
  type: typeof GET_NETWORK_ID_LIST_PENDING
  payload: null
}

export interface GetNetworkIdListFulfilledAction extends AnyAction {
  type: typeof GET_NETWORK_ID_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<NetworkId>>
}

export interface GetNetworkIdAction extends AnyAction {
  type: typeof GET_NETWORK_ID
  payload: AxiosPromise<ServerResponse<NetworkId>>
}

export interface GetNetworkIdPendingAction extends AnyAction {
  type: typeof GET_NETWORK_ID_PENDING
  payload: null
}

export interface GetNetworkIdFulfilledAction extends AnyAction {
  type: typeof GET_NETWORK_ID_FULFILLED
  payload: AxiosResponse<ServerResponse<NetworkId>>
}

export interface CreateNetworkIdThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface CreateNetworkIdAction extends AnyAction {
  type: typeof CREATE_NETWORK_ID
  payload: AxiosPromise<ServerResponse<NetworkId>>
}

export interface CreateNetworkIdPendingAction extends AnyAction {
  type: typeof CREATE_NETWORK_ID_PENDING
  payload: null
}

export interface CreateNetworkIdFulfilledAction extends AnyAction {
  type: typeof CREATE_NETWORK_ID_FULFILLED
  payload: AxiosResponse<ServerResponse<NetworkId>>
}

export interface CreateNetworkIdRejectedAction extends AnyAction {
  type: typeof CREATE_NETWORK_ID_REJECTED
  payload: AxiosResponse<ServerResponse<NetworkId>>
}

export interface UpdateNetworkIdThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface UpdateNetworkIdAction extends AnyAction {
  type: typeof UPDATE_NETWORK_ID
  payload: AxiosPromise<ServerResponse<NetworkId>>
}

export interface DeleteNetworkIdThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface DeleteNetworkIdAction extends AnyAction {
  type: typeof DELETE_NETWORK_ID
  payload: AxiosPromise<ServerResponse<NetworkId>>
}

export interface DeleteNetworkIdFulfilledAction extends AnyAction {
  type: typeof DELETE_NETWORK_ID_FULFILLED
  payload: AxiosResponse<ServerResponse<NetworkId>>
}

export interface DeleteNetworkIdRejectedAction extends AnyAction {
  type: typeof DELETE_NETWORK_ID_REJECTED
  payload: AxiosResponse<ServerResponse<NetworkId>>
}

export interface SelectNetworkIdAction extends AnyAction{
  type: typeof SELECT_NETWORK_ID
  payload: NetworkId[]
}

export type NetworkIdActionTypes =
  GoToNetworkIdListAction |
  SetNetworkIdLoadingAction |
  GetNetworkIdListAction |
  GetNetworkIdListPendingAction |
  GetNetworkIdListFulfilledAction |
  GetNetworkIdAction |
  GetNetworkIdPendingAction |
  GetNetworkIdFulfilledAction |
  CreateNetworkIdAction |
  CreateNetworkIdPendingAction |
  CreateNetworkIdFulfilledAction |
  CreateNetworkIdRejectedAction |
  DeleteNetworkIdAction |
  DeleteNetworkIdFulfilledAction |
  DeleteNetworkIdRejectedAction |
  SelectNetworkIdAction;
